import { LoadingDialog } from '@/components/controls';
import { addDays, startOfDay } from 'date-fns';
import { useMemo } from 'react';
import { IntelligenceItemEditorDialog } from './IntelligenceItemEditorDialog';
import { useDeleteIntelligenceItem } from './useDeleteIntelligenceItem';
import { useIntelligenceItem } from './useIntelligenceItem';
import { useUpsertIntelligenceItem } from './useUpsertIntelligenceItem';

export function IntelligenceItemEditor({ code, isOpen, onClose, groupCodes }) {
  const today = startOfDay(new Date()).toISOString();
  const defaultItem = useMemo(
    () => ({
      expiryDate: addDays(new Date(today), 10),
      groupCodes: groupCodes ?? [],
      title: '',
      message: '',
      categories: [],
      intelligenceId: '',
      nominalIds: [],
      imageSrcs: [],
    }),
    [groupCodes, today],
  );
  const {
    query: { data: fetchedItem },
  } = useIntelligenceItem(code);
  const item = code === 'new' ? defaultItem : fetchedItem;
  const { mutateAsync: upsertItem } = useUpsertIntelligenceItem();
  const { mutate: deleteItem, isPending: isDeleting } =
    useDeleteIntelligenceItem();

  async function handleClose(values) {
    if (values) {
      await upsertItem(values);
    }

    onClose();
  }

  function handleDelete() {
    deleteItem(code);

    onClose();
  }

  return item ? (
    <IntelligenceItemEditorDialog
      item={item}
      isOpen={isOpen}
      onClose={handleClose}
      onDelete={handleDelete}
      isDeleting={isDeleting}
    />
  ) : (
    <LoadingDialog isOpen={isOpen} />
  );
}
